import { render, staticRenderFns } from "./UnitAttributes.vue?vue&type=template&id=c3916708&"
import script from "./UnitAttributes.vue?vue&type=script&lang=js&"
export * from "./UnitAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports